<template lang="pug">

  section.container.error-page.fill-height

    v-row(class="text-center" justify="center")

      v-col(cols="auto")

        //- h1(class="px-5 py-2 title font-weight-black") 404

        h1(class="px-5 py-2 text-h2 mb-9" style="color: #FFFFFF")
          b Página não&nbsp;
          br
          b encontrada!

        v-btn(depressed to="/admin/grupos" v-if="userSession.loggedIn === true")
          | Voltar para o gestor

        v-btn(depressed to="/login" v-else)
          | Voltar para o gestor

</template>

<script>

  import { mapState } from 'vuex'

  export default {
    name: 'PageNotFound',

    computed: {
      ...mapState(['userSession']),
    },
  }

</script>

<style lang="scss" scoped>

  .error-page {
    h1 {
      font-size: 12rem;
    }
  }

</style>
